import React, {useContext} from 'react';
import {Route, Switch, Redirect} from "react-router-dom";
import About from "./components/About";
import Home from "./components/Home";
import Webmap from "./components/Webmap";
import DockyardList from "./components/dockyard/DockyardList";
import {MapContext} from "./context/MapContext";
import GenericNotFound from "./components/GenericNotFound";

const RouterApp = () => {
    const {mapContext} = useContext(MapContext);
    return (
        <Switch>
            <Route exact path="/" component={Home}/>
            <Route path="/chantiers/:id"
                   render={props => mapContext.divisionData ? <DockyardList {...props} /> : <Redirect to='/'/>}>
            </Route>
            <Route exact path="/carte"
                render={
                    props => mapContext.dockyardData && mapContext.divisionData ?
                    <Webmap {...props} /> : <Redirect to='/'/>
                }>
            </Route>
            <Route exact path="/a-propos" component={About}/>
            <Route path="/404" component={GenericNotFound} />
            <Redirect to="/404" />
        </Switch>
    );
};

export default RouterApp;